import { getRecipientWellsFromComposeViewState } from './getAllRecipientsAsEmailAddressStrings';
import getCurrentFromAddress from './getCurrentFromAddress';
import ComposeViewState from '../store/schema/ComposeViewState';
import { isFeatureEnabled } from 'owa-feature-flags';
import { InfoBarMessageRank } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { getSharingDataFromLink, lazyGetSharingTipRecipientInfo } from 'owa-link-data';
import {
    lazyGetSharingIssuesForSharingData,
    getSharingTipIdsList,
    SharingTipId,
    SharingData,
    SharingTipRecipientInfo,
} from 'owa-sharing-data';

export async function getHasSharingIssues(viewState: ComposeViewState): Promise<boolean> {
    // This is only being used for block on send for now, and this will tie its roll out to contextual tips
    // for links in the body. If this method is going to be re-used for something besides block on send
    // we should move this flight check to validateSend.ts and to doAnyLinksHaveSharingIssues
    if (!isFeatureEnabled('doc-attachment-contextualSharingTips')) {
        return false;
    }
    const sharingTipIds: SharingTipId[] = getSharingTipIdsList();
    const hasRefAttachmentWithIssues: boolean =
        viewState.infoBarIds.filter(id => (<string[]>sharingTipIds).indexOf(id) !== -1).length !==
        0;
    const hasLinkWithIssues: boolean = await doAnyLinksHaveSharingIssues(viewState);
    return hasRefAttachmentWithIssues || hasLinkWithIssues;
}

async function doAnyLinksHaveSharingIssues(viewState: ComposeViewState): Promise<boolean> {
    const linkIds = viewState.attachmentWell.sharingLinkIds;
    if (!linkIds || linkIds.length === 0) {
        return false;
    }

    const getSharingTipRecipientInfo = await lazyGetSharingTipRecipientInfo.import();
    const getSharingIssuesForSharingData = await lazyGetSharingIssuesForSharingData.import();

    const sharingData: SharingData[] = linkIds.map(id => getSharingDataFromLink(id));
    const recipientInfo: SharingTipRecipientInfo[] = getSharingTipRecipientInfo(
        getRecipientWellsFromComposeViewState(viewState),
        getCurrentFromAddress(viewState.toRecipientWell)
    );

    return sharingData.some(
        data =>
            getSharingIssuesForSharingData(data, recipientInfo).filter(
                issue => issue.messageRank === InfoBarMessageRank.Error
            ).length > 0
    );
}
